import React from 'react'
import { InertiaLinkProps, Link } from '@inertiajs/react'

const XLink: (props: InertiaLinkProps) => React.JSX.Element = (props) => {
  return (
    <Link className="text-blue-3 hover:text-blue-8 no-underline" {...props}>
      {/* eslint-disable-next-line react/prop-types */}
      {props.children}
    </Link>
  )
}

export default XLink
